const TIMEOUT = 60 * 1000 // 60 minutes in ms

// data structure: { receipt: Base64 string | undefined, error: string | undefined }

export default function (appleId, username) {
  return this.sendEventWithCallback(
    'subscription.buy.ios',
    {
      apple_id: appleId,
      username,
    },
    TIMEOUT
  ).then(data => {
    // shortcut
    if (data.receipt || data.error) {
      return data
    }

    return Promise.reject(
      new Error(this.ERROR_UNKNOWN)
    )
  })
}
